export const METER_BAR_CHART_ARIA_LABEL = 'Meter Bar Chart';
export const METER_BAR_CHART_PLOT_ARIA_LABEL = 'Chart Plot Area';
export const METER_BAR_CHART_THRESHOLDS_ARIA_LABEL = 'Threshold Intervals';

/**
 * Threshold interval bar sizing, in pixels. The interval bars, their gaps, and
 * their offset from the meter bar all scale with the meter bar thickness so the
 * visual density stays balanced as the chart is resized (APPDEV-17783).
 */
export const THRESHOLD_INTERVAL_MIN_THICKNESS = 2;
export const THRESHOLD_INTERVAL_MAX_THICKNESS = 4;
export const THRESHOLD_INTERVAL_MIN_GAP = 2;
export const THRESHOLD_INTERVAL_MAX_GAP = 4;
export const THRESHOLD_INTERVAL_MIN_OFFSET = 2;
export const THRESHOLD_INTERVAL_MID_OFFSET = 4;
export const THRESHOLD_INTERVAL_MAX_OFFSET = 4;

/** Any threshold interval renders at least this wide so it stays visible. */
export const THRESHOLD_INTERVAL_MIN_LENGTH = 8;
